import React, { useState, useEffect } from 'react';
import '../styles/HeroCarousel.css';

// Import images from assets folder
import fot1 from '../assets/fot1.webp';
import fot2 from '../assets/fot2.webp';
import fot3 from '../assets/fot3.webp';
import lawn1 from '../assets/lawn1.webp';
import lawn7 from '../assets/lawn7.webp';
import pad3 from '../assets/pad3.webp';

const HeroCarousel = ({ openBookingModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const slides = [
    { image: fot1 },
    { image: fot2 },
    { image: fot3 },
    { image: lawn1 },
    { image: lawn7 },
    { image: pad3 }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const updateCarousel = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="hero-carousel" id="heroCarousel">
      <div 
        className="carousel-slides" 
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div 
            key={index}
            className="carousel-slide" 
            style={{ backgroundImage: `url(${slide.image})` }}
          ></div>
        ))}
      </div>
      <div className="carousel-overlay"></div>
      <div className="fixed-content">
        <div className="content-wrapper">
          <div className="hero-heading">
            <h1>Find & book sports grounds in Dubai · football, cricket & more</h1>
            <p><strong>BookMyGround</strong> makes sports simple — players, teams & academies instantly connect with top venues.</p>
          </div>
          <div className="short-version-fixed">
            <p>“Find and book sports grounds near you in minutes. Football, cricket, and multi-sport venues across Dubai—all in one place.”</p>
          </div>
        </div>
      </div>
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <span 
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => updateCarousel(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;